import { Checkbox, Group, Stack, Title, Text } from '@mantine/core';
import { GroupLabel } from 'components/GroupLabel';
import { useCreatePrescriptionFormContext } from 'context/FormContext';
import { useTranslation } from 'react-i18next';
import { PatientProfile } from 'utils/models';

interface FormPrescriptionDeactivationProps {
  patient: PatientProfile;
}

export const FormPrescriptionDeactivation = ({ patient }: FormPrescriptionDeactivationProps) => {
  const { t } = useTranslation();
  const { getInputProps, values } = useCreatePrescriptionFormContext();

  return (
    <Stack px={'md'}>
      <Title
        tt={'uppercase'}
        order={4}
        c={'var(--mantine-color-turquoise-9)'}
        data-testid={'title-prescription-deactivation'}
      >
        {t('deactivation_options_label')}
      </Title>
      <Text data-testid={`label-prescription-deactivation`}>{t(`deactivation_options_description`)}</Text>
      <Checkbox.Group {...getInputProps(`deactivationGroupIds`)}>
        {patient.groups
          .filter((group) => !group.expired)
          .map((group) => (
            <Group key={group.id}>
              <Checkbox value={group.id} disabled={group.id === values.groupId} />
              <GroupLabel group={group} showDaysLeftLabel />
            </Group>
          ))}
      </Checkbox.Group>
    </Stack>
  );
};
